import { useEffect } from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { ErrorBox, Loading } from './Feedback';
import { useAuth } from '../lib/auth';
import { moduleDestination } from '../lib/modules';
import type { ModuleAlias } from '../types';

export function ModuleEntry() {
  const { ready, modules } = useAuth();
  if (!ready) return <Loading />;
  if (!modules.length) return <Navigate to="/no-module-access" replace />;
  if (modules.length === 1) return <Navigate to={moduleDestination(modules[0]!.alias)} replace />;
  return <Navigate to="/modules" replace />;
}

export function ModuleGuard({ alias }: { alias: ModuleAlias }) {
  const { ready, modules, can } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (!ready || can(alias)) return;
    const timer = window.setTimeout(() => navigate(modules.length === 1 ? moduleDestination(modules[0]!.alias) : modules.length > 1 ? '/modules' : '/no-module-access', { replace: true }), 900);
    return () => clearTimeout(timer);
  }, [alias, can, modules, navigate, ready]);
  if (!ready) return <Loading />;
  if (!can(alias)) return <div className="page-body"><ErrorBox message="403 · Nu aveți acces la acest modul. Drepturile sunt reîncărcate." /></div>;
  return <Outlet />;
}
